import React, { useRef } from 'react';
import { Modal, Button, Form, Divider } from 'semantic-ui-react';
import SignaturePad from 'react-signature-canvas';
import { Checkbox } from 'components/Form/SpecialButtons';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import Select from 'components/Form/Select';

const schemaValidation = Yup.object().shape({
	accept: Yup.boolean().required('Champ requis'),
	motif: Yup.string().when('accept', {
		is: false,
		then: Yup.string().required('Champs requis'),
	}),
	hasHn: Yup.boolean(),
	hasAskedPatient: Yup.boolean(),
});

const SignConsentModal = ({ open, close, onSubmit, consentRefusalReasons }) => {
	const sigPad = useRef(null);

	const clear = () => {
		sigPad.current.clear();
	};

	return (
		<Modal
			open={open}
			onClose={close}
			closeOnEscape={false}
			closeOnDimmerClick={false}
		>
			<Modal.Header>Signature accord pour prise en charge</Modal.Header>
			<Formik
				enableReinitialize
				initialValues={{
					accept: true,
					hasHn: false,
					hasAskedPatient: false,
				}}
				validationSchema={schemaValidation}
				onSubmit={(values) => {
					const signature = sigPad.current
						.getTrimmedCanvas()
						.toDataURL('image/png');
					onSubmit(values, signature);
				}}
			>
				{({ submitForm, values }) => (
					<>
						<Modal.Content>
							<Form>
								<Field
									component={Checkbox}
									name='accept'
									id='accept'
									customlabel='Accord du patient'
									required
								/>

								{!values.accept && (
									<Field
										name='motif'
										customlabel='Motif du refus'
										component={Select}
										options={consentRefusalReasons.list.map((crr) => ({
											value: crr.label,
											label: crr.label,
										}))}
										isCreatable
										required
									/>
								)}

								<Divider />

								<Field
									component={Checkbox}
									name='hasHn'
									id='hasHn'
									customlabel='Prescription avec des analyses "hors nomenclature"'
									required
								/>
								<Divider />

								<Field
									component={Checkbox}
									name='hasAskedPatient'
									id='hasAskedPatient'
									customlabel='Prescription avec des analyses demandées par le patient'
									required
								/>

								<Divider />
								<div style={{ paddingBottom: 5 }}>
									Signature{' '}
									<Button
										onClick={clear}
										color='red'
										content='Effacer'
										style={{ padding: 5, marginLeft: 5 }}
									/>
								</div>
								<SignaturePad
									ref={sigPad}
									canvasProps={{
										style: { border: 'solid 1px black', height: 250 },
									}}
								/>
							</Form>
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
							Annuler
							</Button>
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submitForm();
								}}
							>
								Confirmer
							</Button>
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};

export default SignConsentModal;
